import {PureComponent} from 'react';
import './styles.sass';

export default class Theme extends PureComponent {
  render() {
    return null;
  }
}


// WEBPACK FOOTER //
// ./src/components/layout/Theme/index.js